import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PagingSidePanelType, Box as Section, SidePanel, Tabs } from '@node-space/ui-components'
import { appBannersId } from 'components/app/AppBanners'
import { useComponentHeight } from 'hooks/useComponentHeight'
import { ChannelPayment } from 'types/channels'
import { highlightRowBasedOnId } from 'utils/table/table'
import { sortObjectPropertiesByName } from 'utils/utils'
import ChannelDetails from './ChannelDetails'
import { ChannelPaymentSidePanelHeader } from './ChannelPaymentSidePanelHeader'
import { PayloadView } from './PayloadView'

interface ChannelPaymentSidePanelProps {
  isOpen: boolean
  paging: PagingSidePanelType
  onClose: () => void
  channelPaymentDetails: ChannelPayment
}

export const ChannelPaymentSidePanel = ({
  isOpen,
  paging,
  onClose,
  channelPaymentDetails,
}: ChannelPaymentSidePanelProps) => {
  const { t } = useTranslation()
  const bannerSpacing = useComponentHeight(appBannersId)

  const { reference, hash, dateCreated } = channelPaymentDetails || {}
  const smallTabsId = `${reference}-${hash}-${dateCreated}`

  const [activeId, setActiveId] = useState(smallTabsId)

  useEffect(() => {
    setActiveId(smallTabsId)
  }, [activeId])

  const transactionRowId = `${channelPaymentDetails?.reference}-${channelPaymentDetails?.hash}-${channelPaymentDetails?.dateCreated}`
  const payloadJsonString = JSON.stringify(
    sortObjectPropertiesByName(channelPaymentDetails || {}),
    null,
    3
  )

  return (
    <SidePanel
      id="side-panel-transaction-details"
      isOpen={isOpen}
      paging={paging}
      onClose={onClose}
      activeRowId={transactionRowId}
      onActiveRowChange={highlightRowBasedOnId}
      externalStyle={{ top: `${bannerSpacing}px` }}
      header={<ChannelPaymentSidePanelHeader channelPayment={channelPaymentDetails} />}
      body={
        <Section tag="section" width="full" background="layer-1">
          <Tabs
            tabs={[
              {
                id: 'details',
                header: t('details'),
                content: <ChannelDetails channelPayment={channelPaymentDetails} />,
              },
              {
                id: 'full-payload',
                header: t('fullPayload'),
                content: <PayloadView jsonString={payloadJsonString} />,
              },
            ]}
          />
        </Section>
      }
    ></SidePanel>
  )
}
